import React from "react";

export default (fn) => (Component) => {
  return class OnMount extends React.Component {
    state = {};

    constructor() {
      super();
      this.setState = this.setState.bind(this);
    }

    loader = () => {
      const result = fn(this.props)(this.setState);
      if (result && result.then) {
        result.then((i) =>
          this.setState({
            ...i,
            ready: true,
          })
        );
      }
    };

    componentDidMount = () => {
      return this.loader();
    };

    render = () => {
      const props = this.props;
      const { ready, ...state } = this.state;
      if (!ready) return null;
      return <Component setState={this.setState} {...props} {...state} />;
    };
  };
};
